var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"loading":_vm.loading,"label":"CEP","value":_vm.value,"mask":"#####-###","return-masked-value":""},on:{"input":_vm.onInput,"focus":_vm.onFocus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }